import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = comics.filter((c) => c.rating >= 9.6).slice(0, 6);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14" aria-labelledby="featured-title">
      <div className="flex items-center justify-between mb-6">
        <h2 id="featured-title" className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
          精选推荐
        </h2>
        <Link
          to="/category/danmei"
          className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
        >
          更多推荐
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
        {featured.map((comic) => (
          <Link
            key={comic.id}
            to={`/comic/${comic.id}`}
            className="group cursor-pointer"
          >
            <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-100 mb-2">
              <img
                src={comic.cover}
                alt={comic.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute top-2 left-2 px-1.5 py-0.5 rounded text-[10px] font-medium bg-primary-500 text-background-50">
                {comic.rating}
              </div>
              {comic.status === '连载中' && (
                <div className="absolute bottom-0 left-0 right-0 py-1 bg-accent-500/90 text-center text-[10px] font-medium text-background-50">
                  连载中
                </div>
              )}
              {comic.status === '已完结' && (
                <div className="absolute bottom-0 left-0 right-0 py-1 bg-foreground-700/80 text-center text-[10px] font-medium text-background-50">
                  已完结
                </div>
              )}
            </div>
            <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
              {comic.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-0.5">{comic.author}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}